import { render } from "./UserDetailView.vue?vue&type=template&id=3578e887&scoped=true"
import script from "./UserDetailView.vue?vue&type=script&lang=js"
export * from "./UserDetailView.vue?vue&type=script&lang=js"

import "./UserDetailView.vue?vue&type=style&index=0&id=3578e887&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3578e887"]])

export default __exports__